import React, { useContext, useEffect, useState } from "react";
import "./JobCategory.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/swiper-bundle.css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import { Pagination, Autoplay, Navigation } from "swiper/modules";
import PropTypes from "prop-types";

import { useNavigate } from "react-router-dom";
import { Context } from "../../../../utils/context";
import Common_Title from "../../../common_components/common_title/Common_Title";

const JobCategory = ({ alignment }) => {
  const { getData, imageUrl, NoDataAnimations } = useContext(Context);
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  const getAllData = async () => {
    const res = await getData("/without-login/home/popular-job");
    setData(res?.data);
  };

  useEffect(() => {
    getAllData();
  }, []);

  return (
    <section className="JobCategory">
      <div className="container">
        <div className="row">
          <div className="col-xxl-12 col-lg-12 mx-auto">
            <Common_Title title="Popular " subTitle={" Job Categories"} />

            <div className="swiper_div">
              <Swiper
                modules={[Autoplay, Pagination, Navigation]}
                loop={true}
                loopAdditionalSlides={2}
                breakpoints={{
                  0: { slidesPerView: 1.3, spaceBetween: 10 },
                  360: { slidesPerView: 1.5, spaceBetween: 10 },
                  485: { slidesPerView: 2, spaceBetween: 10 },
                  640: { slidesPerView: 3.5, spaceBetween: 10 },
                  768: { slidesPerView: 4, spaceBetween: 10 },
                  1024: { slidesPerView: 5, spaceBetween: 10 },
                }}
                pagination={{ clickable: true }}
                autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                  }}

                   freeMode={true}
              >
                {data?.map((val, index) => (
                  <SwiperSlide key={index}>
                    <div
                      className="job_category_div"
                      onClick={() => navigate(`/jobexp?id=${val?.name}`)}
                    >
                      <div className="img_holder">
                        <img
                          src={imageUrl + val?.image}
                          className="img_class"
                          alt={val?.name}
                        />
                      </div>
                      <div className="content_section">
                        <h3 className="category_name">{val?.name}</h3>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>

              {data?.length === 0 && <NoDataAnimations />}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

JobCategory.propTypes = {
  alignment: PropTypes.oneOf(["left", "center"]).isRequired,
};

export default JobCategory;